export default {
    sun: 'S',
    mon: 'M',
    tues: 'T',
    wednes: 'W',
    thurs: 'TH',
    fri: 'F',
    satur: 'SA'
}
